import React, { Component } from 'react';
// import {createPortal} from 'react-dom';
import { Link } from 'react-router-dom';
// import {Manager, Reference, Popper} from 'react-popper';
import Moment from 'moment';
import 'moment/locale/uk';
import map from 'lodash/map';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';

Moment.locale('uk');

const today = date => date.isSame(Moment().utc(), 'day');
const tomorrow = date => date.isSame(Moment().utc().add(1, 'day'), 'day');
const displayDate = date => {
  if (today(date)) {
    return 'Сьогодні';
  }
  if (tomorrow(date)) {
    return 'Завтра';
  }
  return date.format('D MMMM');
};
const displayWeekday = date => today(date) || tomorrow(date) ? date.format('D MMMM') : date.format('dddd');

function Movie({ Id, Name, Sessions, innerPoster }) {
  const ticketsAvailable = Sessions.length > 0;
  return (
    <Link to={`/movie/${Id}`} className={'soon-page-movie'}>
      <div className={'soon-page-movie-thumbnail'}>
        {ticketsAvailable && <span className={'tickets-badge'}>Квитки у продажу</span>}
        <div className={'poster'} style={{ 'backgroundImage': `url('${innerPoster}')` }}></div>
      </div>
      <h2>{Name}</h2>
    </Link>
  );
}

function MovieGroup({ dateFrom, movies }) {
  return (
    <div className={'soon-page-movie-group'}>
      <div className={'date-heading'}>
        <span className={'date'}>{displayDate(dateFrom)}</span>
        <span className={'weekday'}>{displayWeekday(dateFrom)}</span>
      </div>
      <ul className={'movie-list'}>
        {map(movies, movie => (
          <li
            className={'movie-list-item'}
            key={movie.Id}
          >
            <Movie {...movie} />
          </li>
        ))}
      </ul>
    </div>
  );
}

class SoonPage extends Component {
  getMovieGroups() {
    const { soon } = this.props;

    return orderBy(
      map(
        groupBy(soon.films, 'DateFrom'),
        group => {
          const { DateFrom: dateFrom } = group[0];
          const date = Moment.utc(dateFrom);
          return {
            id: dateFrom,
            movies: group,
            dateFrom: date,
          };
        },
      ),
      group => group.id,
    );
  }

  render() {
    const groups = this.getMovieGroups();
    return (
      <div className={'soon-page'}>
        <div className={'soon-page-head-section'}>
          <h1 className={'heading'}>Скоро в кіно</h1>
        </div>
        <ul className={'soon-page-list'}>
          {map(groups, group => (
            <li className={'soon-page-list-item'} key={group.id}>
              <MovieGroup {...group} />
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default SoonPage;


// WEBPACK FOOTER //
// ./src/components/pages/SoonPage/index.js